'use strict';
outstandingCheckInquiryController.$inject = [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'$filter',
	'reportHelper',
	'authService',
	'outstandingCheckService',
	'bankService',
	'USER_CLAIMS',
	'BUSY_MESSAGE',
	'$uibModal',
];
angular.module('schoolLinqApp').controller('outstandingCheckInquiryController', outstandingCheckInquiryController);

function outstandingCheckInquiryController(
	$scope,
	$rootScope,
	$q,
	$interval,
	$filter,
	reportHelper,
	authService,
	outstandingCheckService,
	bankService,
	USER_CLAIMS,
	BUSY_MESSAGE,
	$uibModal
) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	if ($rootScope.mode && $rootScope.mode === 'sa') {
		$scope.vm.module = 'sa';
	}

	$scope.$watch(
		'vm.filter.fromDT',
		function (newFromDT, oldFromDT) {
			if (newFromDT === undefined || newFromDT === oldFromDT) {
				return;
			}
		},
		true
	);

	$scope.$watch(
		'vm.filter.toDT',
		function (newToDT, oldToDT) {
			if (newToDT === undefined || newToDT === oldToDT) {
				return;
			}
		},
		true
	);

	$scope.$watch(
		'vm.filter.fromCheck',
		function (newFromCheck, oldFromCheck) {
			if (newFromCheck === oldFromCheck) {
				return;
			}
		},
		true
	);

	$scope.$watch(
		'vm.filter.toCheck',
		function (newToCheck, oldToCheck) {
			if (newToCheck === oldToCheck) {
				return;
			}
		},
		true
	);

	$scope.$watch('vm.filter.includeChecks', function (oldIncludeChecks, newIncludeChecks) {
		if (oldIncludeChecks === newIncludeChecks) {
			return;
		}
	});

	$scope.$watch('vm.filter.includeEFTs', function (oldIncludeEFTs, newIncludeEFTs) {
		if (oldIncludeEFTs === newIncludeEFTs) {
			return;
		}
	});

	$scope.$watch('vm.filter.includeACHs', function (oldIncludeACHs, newIncludeACHs) {
		if (oldIncludeACHs === newIncludeACHs) {
			return;
		}
	});

	$scope.$watch('vm.filter.includeVoids', function (oldIncludeVoids, newIncludeVoids) {
		if (oldIncludeVoids === newIncludeVoids) {
			return;
		}
	});

	$scope.$watch('vm.filter.includeVoidsOnly', function (oldIncludeVoidsOnly, newIncludeVoidsOnly) {
		if (oldIncludeVoidsOnly === newIncludeVoidsOnly) {
			return;
		}
	});

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$q.all([$scope.vm.loadBanks($scope.vm), $scope.vm.searchChecks($scope.vm)]);

	function getViewModel() {
		var model = {
			module: 'fund',

			checks: [],
			banks: [],

			barLimit: 10,
			startIndex: 0,
			filter: {
				type: 'Date Range',
				fromDT: moment().startOf('day').add(-1, 'month').toDate(),
				toDT: moment().startOf('day').toDate(),
				fromCheck: null,
				toCheck: null,
				source: 'Fund Management',
				bankId: 0,
				includeChecks: true,
				includeEFTs: true,
				includeACHs: true,
				includeVoids: true,
				includeVoidsOnly: false,
				propertyName: 'DateCleared',
				reverse: false,
			},
			accessPayroll: false,
			errors: null,
		};

		function searchChecks(model) {
			$scope.loadingPromise = outstandingCheckService.searchChecks(model.filter).then(_.partial(finishSearchingChecks, model));

			function finishSearchingChecks(model, response) {
				if (response.data.isValid === true) {
					model.checks = response.data.checks;
				} else {
					model.errors = model.data.errors;
				}

				return angular.noop;
			}
		}

		function filterTypeChanged(model) {
			if (model.filter.type === 'Date Range') {
				model.filter.fromCheck = null;
				model.filter.toCheck = null;
				model.filter.fromDT = moment().startOf('day').add(-1, 'month').toDate();
				model.filter.toDT = moment().startOf('day').toDate();
			} else {
				model.filter.fromCheck = null;
				model.filter.toCheck = null;
				model.filter.fromDT = null;
				model.filter.toDT = null;
			}
		}

		function sortBy(model, propertyName) {
			model.filter.reverse = model.filter.propertyName === propertyName ? !model.filter.reverse : false;
			model.filter.propertyName = propertyName;
		}

		function openReport(model) {
			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.filter.fromDT,
				ToDT: model.filter.toDT,
				FromCheck: model.filter.fromCheck,
				ToCheck: model.filter.toCheck,
				Source: model.filter.source,
				BankId: model.filter.bankId,
				IncludeChecks: model.filter.includeChecks,
				IncludeEFTs: model.filter.includeEFTs,
				IncludeACHs: model.filter.includeACHs,
				IncludeVoids: model.filter.includeVoids,
				IncludeVoidsOnly: model.filter.includeVoidsOnly,
			};

			reportHelper.getReport($scope, '/api/outstandingcheck/inquiryreport', report, 'CheckInquiryReport.pdf');
		}

		function exportToCSV(model) {
			var entries = [];
			entries.push('Type,Number,Bank,Date Posted,Post Amount,Written To,Email,Invoice #s,Date Cleared,Amount Cleared,Void Date');
			var checkItems = $filter('orderBy')(model.checks, model.filter.propertyName, model.filter.reverse);

			angular.forEach(checkItems, function (check) {
				var itemArray = [];
				itemArray.push(check.RecordType);
				itemArray.push(check.CheckNumber);
				itemArray.push(check.BankName);
				itemArray.push(moment(check.DatePosted).format('MM/DD/YYYY'));
				itemArray.push(check.PostAmount);
				itemArray.push(check.WrittenTo ? '"' + check.WrittenTo + '"' : '');
				itemArray.push(check.Email);
				itemArray.push(check.InvoiceNumbers ? '"' + check.InvoiceNumbers + '"' : '');
				itemArray.push(check.DateCleared ? moment(check.DateCleared).format('MM/DD/YYYY') : '');
				itemArray.push(check.ClearAmount);
				itemArray.push(check.VoidDate ? moment(check.VoidDate).format('MM/DD/YYYY') : '');
				entries.push(itemArray.join(','));
			});

			var file = entries.join('\n');
			var blob = new Blob([file], { type: 'text/csv' });
			saveAs(blob, 'checks.csv');
		}

		function loadBanks(model) {
			return bankService.getBanks(false, true).then(_.partial(finishLoadingBanks, model));

			function finishLoadingBanks(model, response) {
				model.banks = response.data.banks;
				if (model.banks.length === 1) model.filter.bankId = model.banks[0].Id;
				else model.banks.unshift({ Id: 0, DisplayName: 'All' });
				return angular.noop;
			}
		}

		function viewCheck(model, check) {
			$uibModal.open({
				template: require('@ajs/templates/fund/payable/check-inquiry-detail-modal.html'),
				backdrop: 'static',
				keyboard: false,
				scope: $scope,
				controller: [
					'$scope',
					'$uibModalInstance',
					function ($scope, modalInstance) {
						$scope.check = check;
						angular.extend($scope, {
							close: function () {
								modalInstance.close();
							},
						});
					},
				],
			});
		}

		return angular.extend(model, {
			searchChecks: _.partial(searchChecks, model),
			filterTypeChanged: _.partial(filterTypeChanged, model),
			sortBy: _.partial(sortBy, model),
			openReport: _.partial(openReport, model),
			exportToCSV: _.partial(exportToCSV, model),
			loadBanks: _.partial(loadBanks, model),
			viewCheck: _.partial(viewCheck, model),
		});
	}
}
